import React, { useState, useEffect } from 'react';
import { fetchStandings } from '../services/api';
import LeagueSelector from '../tables/LeagueSelector';
import SeasonSelector from '../tables/SeasonSelector';
import StandingsTable from '../tables/StandingsTable';
import '../tables/AppTables.css';

function LeagueTables() {
  const [leagueId, setLeagueId] = useState(null);
  const [season, setSeason] = useState(null);
  const [standings, setStandings] = useState(null);

  useEffect(() => {
    if (leagueId && season) {
      fetchStandings(leagueId, season)
        .then(setStandings)
        .catch(error => console.error(error));
    }
  }, [leagueId, season]);

  return (
    <div className="AppTable">
      <h1>Football League Standings</h1>
      <div className="selectors">
        <LeagueSelector onSelect={setLeagueId} />
        <SeasonSelector onSelect={setSeason} />
      </div>
      <StandingsTable standings={standings} />
    </div>
  );
}

export default LeagueTables;




